<template>
  <span v-if="open" class="bubble_tray_holder">
    <div class="bubble_tray" :style="trayStyle" ref="tray">
      <div class="bubble_tray__pointer" :style="pointerStyle" />
      <div
        class="bubble_tray__content"
        :style="{
          maxHeight: `${this.trayMaxHeight - 16}px`,
        }"
      >
        <slot></slot>
      </div>
    </div>
    <div class="bubble_tray__overlay" @click="close" />
  </span>
</template>

<script>
export default {
  name: "BubbleTray",
  props: {
    width: { type: Number, default: null },
    top: { type: Number, default: null },
    left: { type: Number, default: null },
    right: { type: Number, default: null },
    bottom: { type: Number, default: null },
    pointerPosition: { type: Number, default: null },
    open: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    trayPosition() {
      const trayPosition = {};
      if (this.width !== null) trayPosition.width = `${this.width}px`;
      if (this.top !== null) trayPosition.top = `${this.top}px`;
      if (this.bottom !== null) trayPosition.bottom = `${this.bottom}px`;
      if (this.left !== null) trayPosition.left = `${this.left}px`;
      if (this.right !== null) trayPosition.right = `${this.right}px`;
      return trayPosition;
    },
    trayMaxHeight() {
      return window.innerHeight - this.top || this.bottom;
    },
    trayStyle() {
      return {
        ...this.trayPosition,
        maxHeight: `${this.trayMaxHeight - 16}px`,
      };
    },
    pointerStyle() {
      return this.pointerPosition ? { left: `${this.pointerPosition}%` } : {};
    },
  },
  methods: {
    close() {
      this.$emit("openPercentageChangeRequest", { percentage: 0 });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";
.bubble_tray {
  width: 252px;
  position: fixed;
  z-index: 16;
  background: $white;
  border: 1px solid $grey_mischka;
  border-radius: 4px;
  box-shadow: 0 10px 20px 0 rgba(30, 30, 30, 0.05);
  right: 24px;
}
.bubble_tray__content {
  overflow-x: hidden;
  overflow-y: auto;
}
.bubble_tray__pointer {
  width: 10px;
  height: 10px;
  background: $white;
  border-top: 1px solid $grey_mischka;
  border-right: 1px solid $grey_mischka;
  transform: rotateZ(-45deg);
  position: absolute;
  left: calc(93% - 5px);
  top: -6px;
}
.bubble_tray__overlay {
  position: fixed;
  z-index: 5;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
}
</style>
